<template>
    <v-container fluid>
        <v-card outlined>
            <v-container fluid>
                <v-card-title class="justify-center text-uppercase">Gestion des services</v-card-title>
                <v-list>
                    <v-list-item>
                        <v-switch 
                            :label="$t('location.activateInStorePickup')">
                        </v-switch>
                    </v-list-item>
                    <v-list-item>
                        <v-switch 
                            :label="$t('location.activateClickAndCollect')">
                        </v-switch>
                    </v-list-item>
                    <v-list-item>
                        <v-switch 
                            :label="$t('location.activateEreservation')">
                        </v-switch>
                    </v-list-item>
                    <v-list-item>
                        <v-switch
                            :label="$t('location.activateShipFromStore')">
                        </v-switch>
                    </v-list-item>
                </v-list>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: "ServicesSettings",
}
</script>